const initSlider = () => {
  const sliders = document.querySelectorAll(".product-card-js");
  const dir = document.querySelector("html").getAttribute("dir");

  let nextEl = ".product-button-group .swiper-button-next";
  let prevEl = ".product-button-group .swiper-button-prev";
  if (dir === "rtl") {
    [nextEl, prevEl] = [prevEl, nextEl];
  }
  sliders.forEach((slider, index) => {
    const productSlider = new Swiper(slider, {
      pagination: {
        el: ".product-pagination .swiper-pagination",
        type: "progressbar",
      },
      speed: 600,
      nested: true,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      allowTouchMove: true,
      mousewheel: {
        forceToAxis: true,
      },
      on: {
        slideChange: function () {
          this.slides.forEach((slide) => {
            slide.style.animation = "none";
          });
        },
      },
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const slide = entry.target;

          if (entry.isIntersecting) {
            slide.classList.add("is-visible");
          }
        });
      },
      {
        threshold: 0.6,
      }
    );

    productSlider.slides.forEach((slide) => observer.observe(slide));
  });
};

initSlider();

document.addEventListener("shopify:section:load", function () {
  initSlider();
});
